export const createV2OverviewUrl = (url: string): string => `overview_2_0/${url}`;
